export const REQUEST_STATUS_PENDING = 'Pending';
export const REQUEST_STATUS_SUCCESS = 'Success';
export const REQUEST_STATUS_FAILURE = 'Failure';
